<template>
    <div class="tw-flex tw-flex-wrap tw-w-full tw-px-5">
        <profile class="tw-w-full md:tw-w-4/12 tw-flex tw-pb-4 tw-pr-4" :pageOptions="pageOptions" :subscriber="subscriber" :options="options" :artist="artist" :spotifyArtist="spotifyArtist" :shareLinks="shareLinks"/>
        <section class="tw-w-full md:tw-w-8/12">
            <div id="resultsContainer" class="tw-mb-32 tw-flex tw-flex-wrap tw-w-full tw-mt-5">
                <div class="tw-w-full tw-flex tw-flex-wrap tw--mt-1">
                    <div class="tw-flex tw-w-3/12 tw-px-1 tw-py-1" v-for="media in photos" :key="media.id" >
                        <post-media :media="media" :artist="artist" :post="media.post" />
                    </div>
                </div>
                <infinite-loading @distance="1" :identifier="infiniteId" @infinite="infiniteHandler" class="tw-mt-5 tw-w-full">
                    <div class="tw-w-full tw-items-center tw-h-full tw-justify-center" style="display:flex;" slot="spinner">
                        <v-progress-circular indeterminate color="white"></v-progress-circular>
                    </div>
                    <span slot="no-more"></span>
                    <section class="tw-text-center tw-mt-5 tw-opacity-50 tw-h-32" slot="no-results">
                        <i class="fas fa-heart-broken tw-text-3xl tw-text-white"></i>
                        <p class="tw-text-white tw-font-sans tw-text-xs">Nenhuma foto encontrada.</p>
                    </section>
                </infinite-loading>
            </div>
        </section>
    </div>
</template>

<script>
import Layout from '@/Shared/SingleLayout';
import Index from '@/Pages/backstage/layout';
import Profile from './components/profile';
import EventBus from '@/eventbus';
import InfiniteLoading from 'vue-infinite-loading';
import PostMedia from './components/media';

export default {
    props: ['artist', 'options', 'spotifyArtist', 'shareLinks', 'subscriber', 'pageOptions'],
    components: {Profile, PostMedia, InfiniteLoading},
    layout: (h, page) => {
      return h(Layout, [
        h(Index, [page]),
      ])
    },
    data(){
        return{
            photos: [],
            page: 1,
            infiniteId: +new Date(),
        }
    },
    metaInfo() {
        return {
            title: `${this.artist.nickname}`,
        }
    },
    methods: {
        infiniteHandler($state){
            axios.get('/api/photos/'+this.artist.artista_id+`?page=${this.page}`)
            .then(data => {
                if (data.data.photos.data.length) {
                    this.page += 1;
                    data.data.photos.data.forEach(el => {
                        this.photos.push(el);
                    });
                    $state.loaded();
                } else {
                    $state.complete();
                }
            })
            .catch(error => {
                this.$page.message = error.response.statusText;
            });
        },
    },
    mounted(){
        const vm = this;
        setTimeout(() => {
            EventBus.$emit('artist', {'pageOptions': this.pageOptions, 'artist': this.artist, 'spotifyArtist': this.spotifyArtist});
        }, 10);

        EventBus.$on('reload-photos', e => {
            this.page = 1;
            this.photos = [];
            this.infiniteId = +new Date();
        });
    },
}
</script>

<style>
.v-list{
    padding: 0!important;
}

.post{
    background: #272727!important;
}

#visibility{
    font-size: 0.7em!important;
    padding: 1px 7px!important;
    margin-top: 1px!important;
}

</style>
